import styled from 'styled-components';

export const Container = styled.div`
  grid-column: 2;
  grid-row: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5em;
  height: 100%;
  padding: 0 1em;

  @media (max-width: 768px) {
  }
`;

export const ContentText = styled.div`
  display: grid;
  gap: 0.2em;
  /*@media (max-width: 1024px) {
    width: 420px;
  }*/
`;
